import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, Inject } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ProtocolFolder, actions } from "../store";
import { ProtocolFacade } from "../store/facade";
import { Actions, ofType } from "@ngrx/effects";
import { TranslocoService } from "@jsverse/transloco";
import { NotifyService } from "@ui/notify";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "folder-picker-dialog",
    templateUrl: "./folder-picker-dialog.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class FolderPickerDialogComponent implements OnInit, OnDestroy {
    private _unsubscribeAll = new Subject();

    @Input()
    classes: string[] = ["w-30vw", "sm:w-30vw"];

    folders$: Observable<ProtocolFolder[]>;

    selected: ProtocolFolder;

    constructor(
        private _dialogRef: MatDialogRef<FolderPickerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _facade: ProtocolFacade,
        private _actions$: Actions,
        private _notifyService: NotifyService,
        private _translateService: TranslocoService
    ) {
        this._dialogRef.addPanelClass(["sm-full-screen", "dialog-v2"]);

        this.folders$ = this._facade.folders$;
    }

    ngOnInit() {
        this._facade.select(null);

        this._actions$
            .pipe(ofType(actions.moveProtocolDefinitionAction.complete), takeUntil(this._unsubscribeAll))
            .subscribe((action) => {
                this._notifyService.success(
                    this._translateService.translate("health.engage.protocol-pool.move-definition.successfully-message")
                );
                this._dialogRef.close();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    goBack() {
        this._facade.goBack();
    }

    save() {
        this._dialogRef.close(this.selected);
    }

    closeDialog() {
        this._dialogRef.close();
    }

    handleSelection(folder: ProtocolFolder) {
        this.selected = folder;
    }
}
